import React from "react";
import ReactDOM from "react-dom/client";
import "./main.scss";
import App from "./App";
import { BrowserRouter } from "react-router-dom";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <BrowserRouter basename="/light-dark-mode/">
    <React.StrictMode>
      <App />
    </React.StrictMode>
  </BrowserRouter>
);
